import ClientService from '../../../services/client-service';
import getUserSettingsDataQuery from '../../../graphql/query/get-user-settings-data.graphql';
import getOtpSecretDataQuery from '../../../graphql/query/get-otp-secret-data.graphql';
import saveUserSettingsDataMutation from '../../../graphql/mutation/save-user-settings-data.graphql';
import sendPhoneVerificationCodeMutation from '../../../graphql/mutation/send-phone-verification-code.graphql';
import verifyUserPhoneMutation from '../../../graphql/mutation/verify-user-phone.graphql';
import generateOtpSecretDataMutation from '../../../graphql/mutation/generate-otp-secret-data.graphql';
import verifyUserOtpMutation from '../../../graphql/mutation/verify-user-otp.graphql';
import deleteOtpSecretDataMutation from '../../../graphql/mutation/delete-otp-secret-data.graphql';

export default class SettingsUserApi {
  public static getUserSettingsData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getUserSettingsDataQuery, payload);
  }

  public static getOtpSecretData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getOtpSecretDataQuery, payload);
  }

  public static saveUserSettingsData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveUserSettingsDataMutation, payload);
  }

  public static sendPhoneVerificationCode(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(sendPhoneVerificationCodeMutation, payload);
  }

  public static verifyUserPhone(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyUserPhoneMutation, payload);
  }

  public static generateOtpSecretData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(generateOtpSecretDataMutation, payload);
  }

  public static verifyUserOtp(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(verifyUserOtpMutation, payload);
  }

  public static deleteOtpSecretData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteOtpSecretDataMutation, payload);
  }
}
